import React from 'react';
import styled from 'styled-components';

type RolesAccessSectionProps = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
};

const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: var(--medium-big-padding); /* Figma 28px -> 30px */
  padding: var(--big-padding); /* Figma 42px -> --big-padding (40px) */
  background-color: var(--beige-main);
  border-radius: var(--semi-medium-border-radius);
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h2`
  margin: 0;
  font-size: var(--semi-big-font-size); /* Figma 19px -> 18px */
  font-weight: var(--semibold-font-weight);
  line-height: var(--small-line-height);
`;

const Subtitle = styled.p`
  margin: 0;
  font-size: var(--small-font-size);
  font-weight: var(--regular-font-weight);
  line-height: var(--small-line-height);
`;

export const RolesAccessSection: React.FC<RolesAccessSectionProps> = ({
  title,
  subtitle,
  children,
}) => (
  <Section>
    <Header>
      <Title>{title}</Title>
      {!!subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Header>
    {children}
  </Section>
);

export const RolesAccessPageLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

export const RolesAccessSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--semi-big-padding); /* Figma 36px -> --semi-big-padding (35px) */
  width: 100%;
`;
